import forIn from 'lodash/forIn';
// import isArray from 'lodash/isArray';

const pxPtRatio = 16 / 12;
export const isMeal = (key) => {
  const patt = new RegExp(/(meal-option-)\w+/);
  const res = patt.test(key);
  return res;
};
export const ptToPx = pt => pt * pxPtRatio;
export const pxToPt = px => px / pxPtRatio;
export const isImage = value => (value === 'IMAGE');
export const isText = value => (value === 'TEXT');
export const petite = { w: 552, h: 608 }; // px value
export const size5x7 = { w: 723, h: 740 }; // px value

/* Generic */
export const convertObjToArr = o => Object.keys(o).map(i => o[i]);
export const convertArrToObj = arr => arr.reduce((acc, cur, i) => {
  acc[i] = cur; // eslint-disable-line
  return acc;
}, {});

/* For Card */
const constructElements = (elements) => {
  const groups = [];
  elements.forEach((ele) => {
    const curGroup = {
      photo: '',
      texts: [],
      format: {},
    };
    forIn(ele, (value, key) => {
      if (key === 'fields') {
        value.forEach((field) => {
          if (isImage(field.content_type)) {
            curGroup.photo = field;
            curGroup.photo.custom_image_id = '';
          } else if (isText(field.content_type)) {
            curGroup.texts.push(field);
          }
        });
      } else {
        curGroup.format[key] = value;
      }
    });
    groups.push(curGroup);
  });
  return groups;
};

export const constructTemplate = (template) => {
  const pages = template.pages;
  const pagesInfo = {};
  let pageInfo = {};
  forIn(pages, (page, pageName) => {
    forIn(page, (value, key) => {
      if (key === 'elements') {
        pageInfo = {
          pageName,
        };
        pageInfo[key] = constructElements(value);
      } else {
        pageInfo[key] = value;
      }
    });
    pagesInfo[pageName] = pageInfo;
  });
  return pagesInfo;
};

// SAVE
export const autoSaveTimeSpan = 60 * 1000;

// TODO: depending on the filter name set on backend
export const convertFilterName = (name) => {
  if (name === 'invitation') return 'INVITATION';
  return 'SAVE_THE_DATE';
};

export const pageName = (type) => {
  if (type === 'INVITATION_ENVELOPE') return 'envelope';
  else if (type === 'RSVP_ENVELOPE') return 'rsvpEnvelope';
  else if (type === 'RSVP') return 'rsvp';
  else if (type === 'INVITATION') return 'detailFront';
  return 'detailFront';
};



/** WEBPACK FOOTER **
 ** ./src/cards/util/index.js
 **/